<template>
  <b-container class="home-class">
    <puls-card-header class="text-light" :title="$t('home.header.title')" />
    <Search />
    <b-row>
      <b-col>
        <div class="d-flex gap-10 flex-wrap help-section-cards">
          <puls-navigation-card
            :img="{ src: section.img }"
            :title="section.title"
            :to="{ name: 'Section', params: { section: section.i } }"
            :text="section.text"
            v-for="section in sections"
            :key="section.key"
          />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import en from '../locales/en'
import Search from '../components/Search'
export default {
  name: 'Home',
  components: { Search },

  computed: {
    sections() {
      return Object.keys(en.home.sections).map((key) => {
        const items = en.home.sections[key]
        return {
          i: key,
          ...items,
          title: this.$t(`home.sections.${key}.title`),
          text: this.$t(`home.sections.${key}.text`)
        }
      })
    }
  },
  methods: {
    didClickSection(section) {
      this.$router.push({ name: 'Section', params: { section } })
    }
  }
}
</script>

<style scoped>
.home-class {
  height: 100%;
}
.help-section-cards > .puls-navigation-card {
  min-width: 220px;
}
</style>
